export default function () {
  return {
    consultas: {
      data: [],
    },
  };
}
